import React, { useEffect, useState } from "react";
import {
  Input,
  Space,
  Form,
  Button,
  notification,
  message,
  DatePicker,
} from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import bookingStatusRequest from "./../BookingStatusRequest";

export const UpdateBookingStatus = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // Get the id from the URL params
  const [bookingStatusData, setBookingStatusData] = useState(null);
  const [content, setContent] = useState(""); // State to manage the content for ReactQuill editor

  const fetchBookingStatusData = () => {
    setLoading(true);
    bookingStatusRequest
      .getBookingStatusById(id) // Assuming you have a method to get the policy by ID
      .then((response) => {
        const data = response?.data?.data || {};
        console.log(data);
        setBookingStatusData(data); // Save fetched data to policyData state
        setContent(data.content || ""); // Set the content for ReactQuill editor
        form.setFieldsValue({
          ...data, // Populate the form fields with fetched data
        });
      })
      .catch((error) => {
        message.error("Failed to fetch Booking Status data");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    console.log(values);
    setLoading(true);

    bookingStatusRequest
      .updateBookingStatus(id, values) // Assuming you have an API method for updating policy
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: "Booking Status updated successfully",
          });
          navigate(-1, { state: { refresh: true } }); // Navigate to the previous page
        } else {
          notification.error({
            message: "Something went wrong",
          });
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to update Booking Status",
        });
        console.error("API Error:", e);
      });
  };

  const handleSubmit = () => {
    form.submit(); // Trigger form validation and submission
  };

  useEffect(() => {
    if (id) {
      fetchBookingStatusData(); // Fetch the policy data when editing a policy
    }
  }, [id]);

  return (
    <>
      <section>
        <div className="Create-Category">
          <Form.Item className="text-center submit-btn">
            <Space>
              <Button
                className="f-sub-btn btn-width"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Update Panalty Structure</h3>

          {/* Add Ant Design Form component and pass the form instance */}
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <div className="subscription">
              <Form.Item
                name="statusName"
                label="Status Name"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Status Name",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Status Name" />
              </Form.Item>
            </div>

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};
